import React, { useContext, useState, createContext, Dispatch, SetStateAction } from 'react';
import { SchemaSubmitForm } from '@restspace/schema-form';
import { config } from 'config';
import { User } from 'data/user';

export const UserContext = createContext<[ User, Dispatch<SetStateAction<User>> ]>([ User.AnonUser(), () => {} ]);

const loginSchema = {
    type: "object",
    title: "Log In",
    properties: {
        email: {
            type: "string",
            format: "email"
        },
        password: {
            type: "string",
            format: "password"
        }
    },
    required: [ "email", "password" ]
}

interface ILoginUser {
  email: string;
  password: string;
}

export function Login() {
    const [, setUser] = useContext(UserContext);
    const [loginUser, setLoginUser] = useState({ email: "", password: "" } as ILoginUser);
    const [failed, setFailed] = useState(false);
  
    return (
      <div className="login-panel">
      <SchemaSubmitForm value={loginUser} schema={loginSchema}
        makeSubmitLink={(onSubmit: () => void) => <button type="button" className="jd-submit-button" onClick={onSubmit}>Submit</button>}
        onSubmit={async (value: object) => {
          const loginUser = value as ILoginUser;
          setLoginUser(loginUser);
          const user = await config.api.login(loginUser.email, loginUser.password);
          if (user.isAnon()) {
            setFailed(true);
            loginUser.password = '';
            setLoginUser(loginUser);
            return false;
          }
          setUser(user);
          return true;
        }}
      />
      {failed && <div className='jd-login-message'>Incorrect username or password</div>}
      </div>
    );
  }